document.addEventListener('DOMContentLoaded', () => {


	const target = document.body;
	const config = { attributes: true, childList: true, subtree: true };

	const isElement = (element) => {
		if (element.tagName !== 'DIV') return false;
		if (element.className == null) return false;
		return element.className === 'spr-review';
	}

	const observer = new MutationObserver((records) => {
		records.forEach(record => {
			Array.from(record.addedNodes)
			.filter(node => isElement(node))
				.forEach((element) => {
					const body = element.querySelector('.spr-review-content-body');
					const footer = element.querySelector('.spr-review-footer');
					const button = document.createElement('button');

					body.classList.add('hidden');
					button.className = 'spr-review-more';
					button.textContent = '全文をみる';
					button.addEventListener('click', () => {
						if(button.textContent == '全文をみる') {
							button.textContent = '閉じる';
							body.classList.remove('hidden');
						}else{
							button.textContent = '全文をみる';
							body.classList.add('hidden');
						}
					});
					footer.appendChild(button);
				})
    })
	});

	observer.observe(target, config);


}, false);
